import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
import _imports_0 from '../assets/icon/swap.png';

const _withScopeId = n => (_pushScopeId("data-v-6c3b8bf1"), n = n(), _popScopeId(), n);

const _hoisted_1 = {
  class: "transfer-container"
};
const _hoisted_2 = {
  class: "transfer-select"
};
const _hoisted_3 = {
  class: "select-area"
};

const _hoisted_4 = /*#__PURE__*/_createStaticVNode("<div class=\"select-dot\" data-v-6c3b8bf1><div class=\"dot-item dot-type\" style=\"--dot-color:#04AC92;margin-bottom:5px;\" data-v-6c3b8bf1></div><div class=\"dot-item\" data-v-6c3b8bf1></div><div class=\"dot-item\" data-v-6c3b8bf1></div><div class=\"dot-item\" data-v-6c3b8bf1></div><div class=\"dot-item dot-type\" style=\"--dot-color:#D04C64;margin-top:5px;\" data-v-6c3b8bf1></div></div>", 1);

const _hoisted_5 = {
  class: "select-option"
};
const _hoisted_6 = {
  class: "select-item",
  style: {
    "border-bottom": "1px solid #e6ecf2"
  }
};
const _hoisted_7 = {
  class: "item-prefix"
};
const _hoisted_8 = {
  class: "item-text"
};
const _hoisted_9 = {
  class: "select-item"
};
const _hoisted_10 = {
  class: "item-prefix"
};
const _hoisted_11 = {
  class: "item-text"
};
const _hoisted_12 = {
  class: "transfer-title"
};
const _hoisted_13 = {
  class: "transfer-input-area"
};
const _hoisted_14 = {
  style: {
    "font-size": "13px"
  }
};

const _hoisted_15 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  style: {
    "color": "#8e8f91",
    "margin-right": "8px"
  }
}, "USDT", -1));

const _hoisted_16 = {
  class: "transfer-title"
};
const _hoisted_17 = {
  style: {
    "color": "#969799"
  }
};
const _hoisted_18 = {
  key: 0,
  class: "btn-area"
};
import { ref, onMounted, watch } from 'vue';
import store from '@/store';
import router from '@/router';
import BaseTradeHeader from '@/components/BaseTradeHeader.vue';
import { getUserAsset, transfer } from '@/apis';
import { Toast } from 'vant';
import 'vant/es/toast/style';
import { useWindowSize } from '@vant/use';
import { useI18n } from "vue-i18n";
export default {
  __name: 'TransferView',

  setup(__props) {
    const {
      t
    } = useI18n();
    const {
      height
    } = useWindowSize();
    const oldHeight = height.value;
    watch([height], () => {
      let show = true;

      if (oldHeight - height.value > 120) {
        show = false;
      }

      footerShow.value = show;
    });
    const have = ref({
      asset: 0,
      trade: 0,
      pledge: 0,
      service: 0
    });
    const accountList = [{
      key: 'asset',
      name: 'currencyAccount',
      index: 0
    }, {
      key: 'trade',
      name: 'contractAccount',
      index: 1
    }];
    const fromIndex = ref(0);
    const toIndex = ref(1);
    const transferNum = ref();
    const loading = ref(false);
    const footerShow = ref(true);
    onMounted(async () => {
      if (store.state.token === '') {
        router.replace({
          name: 'login'
        });
        return;
      }

      const toast = Toast.loading({
        duration: 0
      });
      init().finally(() => {
        toast.clear();
      });
    });

    const init = async () => {
      getUserAsset({
        platform: 0
      }).then(res => {
        if (res.code === 200 && res.data) {
          res.data.map(item => {
            if (item.marketSymbol == 'USDT') {
              have.value.asset = Math.floor(item.active * 100000) / 100000;
            }
          });
        }
      });
      getUserAsset({
        platform: 1
      }).then(res => {
        if (res.code === 200 && res.data) {
          const findItem = res.data.find(item => item.marketName === 'USDT');

          if (findItem) {
            have.value.trade = findItem ? Math.floor(Number(findItem.active) * 100000) / 100000 : '0';
          }
        }
      });
    };

    const sideChange = () => {
      [toIndex.value, fromIndex.value] = [fromIndex.value, toIndex.value];
    };

    const commit = async () => {
      if (!transferNum.value || transferNum.value === '') {
        Toast({
          message: t('transferMoney'),
          position: 'bottom'
        });
        return;
      }

      if (Number(transferNum.value) > Number(have.value[accountList[fromIndex.value].key])) {
        Toast({
          message: t('withdrawNumLess'),
          position: 'bottom'
        });
        return;
      }

      loading.value = true;
      const res = await transfer({
        fromAsset: Number(accountList[fromIndex.value].index),
        toAsset: Number(accountList[toIndex.value].index),
        amount: Number(transferNum.value)
      });
      loading.value = false;

      if (res.code === 200) {
        Toast({
          message: t('transferSuccess'),
          position: 'bottom'
        });
        init();
        return;
      }

      Toast({
        message: res.msg !== '' ? res.msg : t('transferError'),
        position: 'bottom'
      });
    };

    return (_ctx, _cache) => {
      const _component_van_icon = _resolveComponent("van-icon");

      const _component_a_menu_item = _resolveComponent("a-menu-item");

      const _component_a_menu = _resolveComponent("a-menu");

      const _component_a_dropdown = _resolveComponent("a-dropdown");

      const _component_a_input = _resolveComponent("a-input");

      const _component_van_button = _resolveComponent("van-button");

      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(BaseTradeHeader, {
        title: _unref(t)('transfer'),
        text: "USDT",
        "history-router": "transferHistory"
      }, null, 8, ["title"]), _createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_hoisted_4, _createElementVNode("div", _hoisted_5, [_createVNode(_component_a_dropdown, null, {
        overlay: _withCtx(() => [_createVNode(_component_a_menu, null, {
          default: _withCtx(() => [(_openBlock(), _createElementBlock(_Fragment, null, _renderList(accountList, (item, index) => {
            return _openBlock(), _createElementBlock(_Fragment, {
              key: index
            }, [index !== toIndex.value ? (_openBlock(), _createBlock(_component_a_menu_item, {
              key: 0,
              onClick: $event => fromIndex.value = index
            }, {
              default: _withCtx(() => [_createTextVNode(_toDisplayString(_unref(t)(item.name)), 1)]),
              _: 2
            }, 1032, ["onClick"])) : _createCommentVNode("", true)], 64);
          }), 64))]),
          _: 1
        })]),
        default: _withCtx(() => [_createElementVNode("div", _hoisted_6, [_createElementVNode("div", _hoisted_7, _toDisplayString(_unref(t)('from')), 1), _createElementVNode("div", _hoisted_8, _toDisplayString(_unref(t)(accountList[fromIndex.value].name)), 1), _createVNode(_component_van_icon, {
          name: "arrow",
          color: "#d4d4da",
          style: {
            "margin-right": "5px"
          }
        })])]),
        _: 1
      }), _createVNode(_component_a_dropdown, null, {
        overlay: _withCtx(() => [_createVNode(_component_a_menu, null, {
          default: _withCtx(() => [(_openBlock(), _createElementBlock(_Fragment, null, _renderList(accountList, (item, index) => {
            return _openBlock(), _createElementBlock(_Fragment, {
              key: index
            }, [index !== fromIndex.value ? (_openBlock(), _createBlock(_component_a_menu_item, {
              key: 0,
              onClick: $event => toIndex.value = index
            }, {
              default: _withCtx(() => [_createTextVNode(_toDisplayString(_unref(t)(item.name)), 1)]),
              _: 2
            }, 1032, ["onClick"])) : _createCommentVNode("", true)], 64);
          }), 64))]),
          _: 1
        })]),
        default: _withCtx(() => [_createElementVNode("div", _hoisted_9, [_createElementVNode("div", _hoisted_10, _toDisplayString(_unref(t)('to')), 1), _createElementVNode("div", _hoisted_11, _toDisplayString(_unref(t)(accountList[toIndex.value].name)), 1), _createVNode(_component_van_icon, {
          name: "arrow",
          color: "#d4d4da",
          style: {
            "margin-right": "5px"
          }
        })])]),
        _: 1
      })])]), _createElementVNode("div", {
        class: "select-r"
      }, [_createElementVNode("img", {
        src: _imports_0,
        onClick: sideChange
      })])]), _createElementVNode("div", _hoisted_12, _toDisplayString(_unref(t)('money')), 1), _createElementVNode("div", _hoisted_13, [_createVNode(_component_a_input, {
        value: transferNum.value,
        "onUpdate:value": _cache[1] || (_cache[1] = $event => transferNum.value = $event),
        class: "transfer-input",
        bordered: false,
        placeholder: _unref(t)('transferMoney'),
        allowClear: "",
        type: "number"
      }, {
        suffix: _withCtx(() => [_createElementVNode("div", _hoisted_14, [_hoisted_15, _createElementVNode("span", {
          onClick: _cache[0] || (_cache[0] = $event => transferNum.value = have.value[accountList[fromIndex.value].key])
        }, _toDisplayString(_unref(t)('all')), 1)])]),
        _: 1
      }, 8, ["value", "placeholder"])]), _createElementVNode("div", _hoisted_16, [_createElementVNode("span", _hoisted_17, _toDisplayString(_unref(t)('useable')) + "：", 1), _createTextVNode(_toDisplayString(have.value[accountList[fromIndex.value].key]), 1)]), footerShow.value ? (_openBlock(), _createElementBlock("div", _hoisted_18, [_createVNode(_component_van_button, {
        type: "primary",
        block: "",
        onClick: commit,
        loading: loading.value,
        style: {
          "--van-button-default-height": "42px",
          "margin-top": "10px",
          "background-color": "#F08504",
          "border-color": "#F08504"
        }
      }, {
        default: _withCtx(() => [_createTextVNode(_toDisplayString(_unref(t)('transfer')), 1)]),
        _: 1
      }, 8, ["loading"])])) : _createCommentVNode("", true)]);
    };
  }

};